<template>
  <div class="step-calculator">
    <div class="row">
      <div class="col-lg-12">
        <div class="card step-border">
          <div class="card-body">
            <v-form @submit.prevent="submitForm">
              <div class="row">
                <div class="col-md-6">
                  <div class="step-input">
                    <label for="monthly-investment" class="label-spacing"
                      >My Monthly Investment</label
                    >
                    <span class="step-group">
                      <div class="rupees-symbol">₹</div>
                      <input
                        type="text"
                        class="form-control"
                        v-model="formData.name"
                        outlined
                        id="monthly-investment"
                      />
                    </span>
                  </div>
                  <div class="step-input">
                    <label for="annual-increase" class="label-spacing"
                      >Annual Increase</label
                    >
                    <span class="step-group">
                      <button type="button" @click="decreaseAnnual">-</button>
                      <input
                        type="text"
                        class="form-control text-center"
                        v-model="formData.annual"
                        outlined
                        id="annual-increase"
                      />
                      <button type="button" @click="increaseAnnual">+</button>
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="step-input">
                    <label for="existing-amount" class="label-spacing"
                      >Existing amount</label
                    >
                    <span class="step-group">
                      <div class="rupees-symbol">₹</div>
                      <input
                        type="text"
                        class="form-control"
                        v-model="formData.existingAmount"
                        outlined
                        id="existing-amount"
                      />
                    </span>
                  </div>
                  <div class="step-input">
                    <label for="time-returns" class="label-spacing"
                      >Expected returns</label
                    >
                    <span class="step-group">
                      <button type="button" @click="decreaseReturns">-</button>
                      <input
                        class="form-control text-center"
                        type="text"
                        v-model="formData.returns"
                        outlined
                        id="time-returns"
                      />
                      <button type="button" @click="increaseReturns">+</button>
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="step-input">
                    <label for="time-period" class="label-spacing"
                      >Number of Years I plan to Invest</label
                    >
                    <span class="step-group">
                      <button type="button" @click="decreaseTimePeriod">
                        -
                      </button>
                      <input
                        type="text"
                        v-model="formData.time"
                        class="form-control text-center"
                        outlined
                        id="time-period"
                      />
                      <button type="button" @click="increaseTimePeriod">
                        +
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-md-6 mb-0" style="align-content: end">
                  <div class="form-group">
                    <button
                      type="button"
                      @click="submitForm()"
                      class="step-button"
                    >
                      Calculate
                    </button>
                  </div>
                </div>
              </div>
            </v-form>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="second-card">
          <div class="row">
            <div class="col-md-4">
              <div class="card step-border-card">
                <div class="card-body step-card-color">
                  <div class="text-center">
                    <label for="total-investment" class="step-card-label"
                      >Total investment</label
                    >
                  </div>
                  <div class="text-center">
                    <input
                      v-model="formattedTotalInvestment"
                      class="step-card-input"
                      id="total-investment"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card step-border-card">
                <div class="card-body step-card-color">
                  <div class="text-center">
                    <label for="time-returns" class="step-card-label"
                      >Estimated Returns</label
                    >
                  </div>
                  <div class="text-center">
                    <input
                      v-model="formattedTotalReturns"
                      class="step-card-input"
                      id="time-returns"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card step-border-card">
                <div class="card-body positiveresult">
                  <div class="text-center">
                    <label for="total-returns">Final value</label>
                  </div>
                  <div class="text-center">
                    <div>
                      <input
                        v-if="finalValue !== null"
                        class="step-card-input"
                        v-model="formattedTotalValue"
                        id="total-returns"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="distribution-bar-container">
              <div class="distribution-label">
                <div class="box1"></div>
                <label for="distribution-bar">Invested Amount</label>
              </div>
              <div class="distribution-label">
                <div class="box2"></div>
                <label for="distribution-bar">Estimated Returns</label>
              </div>
              <br />
              <DistributionBar
                :investment="totalInvestment"
                :estimated-returns="totalDifference"
                :formattedTotalValue="formattedTotalInvestment"
                :formattedTotalReturns="formattedTotalReturns"
              />
              <i class="step-disclaim"
                >Disclaimer: Results shown for illustrative purpose only and
                should not be construed as investment advice</i
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DistributionBar from "./DistributionBar.vue";

export default {
  name: "StepCalculatorDesign",
  components: {
    DistributionBar,
  },
  data() {
    return {
      formData: {
        name: 500,
        annual: "5 %",
        time: "1 Years",
        returns: "12 %",
        existingAmount: 0,
        minValue: 0,
        maxValue: 100,
      },
      totalValue: 0,
      totalDifference: 0,
      formattedTotalInvestment: "₹ 0",
      formattedTotalReturns: "₹ 0",
      formattedTotalValue: "₹ 0",
    };
  },
  created() {
    this.calculateTotalValue();
  },
  computed: {
    totalInvestment() {
      return parseFloat(this.formData.name) || 0;
    },
  },
  methods: {
    submitForm() {
      this.calculateTotalValue();
    },
    calculateTotalValue() {
      const sip_amt = parseInt(this.formData.name);
      const current = parseInt(this.formData.existingAmount) || 0;
      const dur = parseInt(this.formData.time);
      let step = parseInt(this.formData.annual) / 100;
      const rate2 = parseFloat(this.formData.returns);
      const rate = (rate2 / 365) * 30.421;
      let df = [];
      for (let i = 0; i < dur; i++) {
        for (let j = 0; j < 12; ++j) {
          let row = i * 12 + j;
          if (i === 0 && j === 0) {
            df[0] = [];
            df[0][0] = 1;
            df[0][1] = 1;
            df[0][2] = sip_amt;
            df[0][3] = current + sip_amt;
            df[0][4] = current + sip_amt;
          } else {
            if (j === 0) {
              df[row] = [];
              df[row][0] = df[row - 1][0] + 1;
              df[row][1] = j + 1;
              df[row][2] = df[row - 1][2] + step * df[row - 1][2];
              df[row][3] = df[row - 1][3] + df[row][2];
              df[row][4] =
                df[row - 1][4] * (1 + rate / 100) +
                df[row][2] * (1 + rate / 100);
            } else {
              df[row] = [];
              df[row][0] = df[row - 1][0];
              df[row][1] = j + 1;
              df[row][2] = df[row - 1][2];
              df[row][3] = df[row - 1][3] + df[row][2];
              df[row][4] =
                df[row - 1][4] * (1 + rate / 100) +
                df[row][2] * (1 + rate / 100);
            }
          }
        }
      }

      const formatter = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
      });

      const final = df[df.length - 1][3];
      this.formattedTotalInvestment = formatter.format(final);
      const returns = df[df.length - 1][4] - final;
      this.formattedTotalReturns = formatter.format(returns);
      this.formattedTotalValue = formatter.format(final + returns);
    },
    increaseReturns() {
      const numericValue = parseFloat(this.formData.returns);
      if (numericValue < 5.5) {
        this.formData.returns = `${Math.min(numericValue + 0.5, 5.5)} %`;
      } else if (numericValue < 20) {
        this.formData.returns = `${numericValue + 0.5} %`;
      }
    },
    decreaseReturns() {
      const numericValue = parseFloat(this.formData.returns);
      if (numericValue <= 5.5) {
        if (numericValue > 5) {
          this.formData.returns = `${Math.max(numericValue - 0.5, 5)} %`;
        }
      } else {
        this.formData.returns = `${numericValue - 0.5} %`;
      }
    },
    increaseAnnual() {
      const numericValue = parseFloat(this.formData.annual);
      if (numericValue < 50) {
        this.formData.annual = `${numericValue + 1} %`;
      }
    },
    decreaseAnnual() {
      const numericValue = parseFloat(this.formData.annual);
      if (numericValue > 5) {
        this.formData.annual = `${numericValue - 1} %`;
      }
    },
    increaseTimePeriod() {
      const numericValue = parseFloat(this.formData.time);
      if (numericValue < 50) {
        this.formData.time = `${numericValue + 1} years`;
      }
    },
    decreaseTimePeriod() {
      const numericValue = parseFloat(this.formData.time);
      if (numericValue > 1) {
        this.formData.time = `${numericValue - 1} years`;
      }
    },
  },
};
</script>

<style scoped>
.step-calculator .step-input label {
  display: block;
  font-weight: bold;
  text-align: justify;
  font-size: 16px;
  color: #012e40 !important;
}

.step-input input {
  text-align: justify;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.step-calculator .step-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.step-button {
  width: 100%;
  background: #00a3d9;
  color: white;
  padding: 0.6em;
  margin: 0px 0 12px;
  border-radius: 5px;
}

.step-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
}

.label-spacing {
  margin-bottom: 0.7rem;
}

.step-border {
  border: none;
  outline: none;
  background: none;
}

.step-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;
}

.step-border-card {
  border: none;
}

.step-card-color {
  background: #f8f9fa;
  border-radius: 10px;
}

.step-card-label {
  font-weight: bold;
  text-align: center;
}

.step-card-input {
  text-align: center;
  border: none;
  outline: none;
  background: transparent;
}

.second-card {
  border: none !important;
  padding: inherit;
  margin-top: -53px;
}

.positiveresult {
  background: rgba(56, 226, 178, 0.2);
  border-radius: 10px;
}
.positiveresult label {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #012e40;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}
.positiveresult input {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #012e40;
  text-shadow: 3px 3px 8px rgba(0, 255, 87, 0.25);
  border: none;
  text-align: center;
  background: none;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
  margin: 10px;
}

.distribution-label {
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 5px;
  padding: inherit;
}

.distribution-bar {
  padding: inherit;
}

.distribution-label .box1 {
  width: 30px;
  height: 10px;
  background-color: #205aa6;
  margin-right: 10px;
}

.distribution-label .box2 {
  width: 30px;
  height: 10px;
  background-color: #21d19f;
  margin-right: 10px;
}

.step-disclaim {
  color: #918d99;
  font-size: 14px;
}
</style>
